import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import "primeflex/primeflex.css";
import { userService } from "../../service/User/user.service";
import { useAuthContext } from "../../context/AuthContext";
import { updateAbility } from "../../ability/ability";
import { buildApiUrl } from "../../config/api";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setCurrentUser } = useAuthContext();

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(buildApiUrl("/api/login/"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        userService.getCurrentUser().then((res) => {
          if (res?.data?.success) {
            setCurrentUser(res?.data?.data);
            updateAbility(res?.data?.data?.permissions || []);
          }
        });
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("refresh_token", data.refresh_token);
        localStorage.setItem("loggedIn", "true");

        navigate("/user-roles");
      } else {
        setError(data.error || "Invalid username or password");
      }
    } catch {
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-content-center align-items-center p-3">
      <Card title="Login" className="p-4 w-full md:w-4">
        <form onSubmit={handleSubmit} className="flex flex-column gap-4">
          <div className="flex flex-column gap-2">
            <label>Username</label>
            <InputText
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full"
              placeholder="Enter username"
            />
          </div>

          <div className="flex flex-column gap-2 w-full">
            <label>Password</label>
            <Password
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
              toggleMask
              required
              className="w-full" // expands the whole component
              inputClassName="w-full"
              placeholder="Enter password"
            />
          </div>

          {error && <Message severity="error" text={error} />}

          <Button
            label={loading ? "Logging in…" : "Login"}
            type="submit"
            loading={loading}
            className="w-full"
          />
        </form>
      </Card>
    </div>
  );
};

export default Login;
